<template>
    <div class="main">
        <div>
            <h3 style="font-size:28px;line-height:45px">Purchase Orders</h3>
            <!-- <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            </p> -->
        </div>
        <div class="purchase-container">
            <a-row type="flex" justify="space-between">
              <a-col @click="showPurchaseOrderModal" class="box-container" :span="11"> 
                    <a-col class="box-alignment">
                        <div>
                            <img class="imgSize" src="../../assets/img/create-po.png"/>
                        </div>
                        <div class="ml-3">
                            <p class="box-header">Generate on the fly</p>
                            <p class="box-content">
                                Want to quickly generate a Purchase Order on the fly? Click here to get started
                            </p>
                        </div>
                    </a-col>
              </a-col>
              <a-col @click="showBackOrderModal" class="box-container" :span="11"> 
                    <a-col class="box-alignment">
                        <div>
                            <img class="imgSize" src="../../assets/img/backorder.png"/>
                        </div>
                        <div class="ml-3">
                            <p class="box-header">Generate from backorders</p>
                            <p class="box-content">
                                Generate PO from backorders in 3 steps. Get Started? Click here to get started
                            </p>
                        </div>
                    </a-col>
              </a-col>
            </a-row>
            <a-row class="mt-5" type="flex" justify="space-between">
                <a-col @click="redirectToRelenish" class="box-container" :span="11"> 
                        <a-col class="box-alignment">
                            <div>
                                <img class="imgSize" src="../../assets/img/replenish.png"/>
                            </div>
                            <div class="ml-3">
                                <p class="box-header">Replenish</p>
                                <p class="box-content">
                                    Want to check stock levels at a glance? Click here to get started
                                </p>
                            </div>
                        </a-col>
                </a-col>
                <a-col @click="redirectToPurchaseOrderHistory" class="box-container" :span="11"> 
                        <a-col class="box-alignment">
                            <div>
                                <img class="imgSize" src="../../assets/img/po-history.png"/>
                            </div>
                            <div class="ml-3">
                                <p class="box-header">View PO history</p>
                                <p class="box-content">
                                    Want to view purchase orders history at a glance? Get started here
                                </p>
                            </div>
                        </a-col>
                </a-col>
            </a-row>
        </div>
        <!-- Create Purchase Order -->
        <a-modal
        class="modalStyle"
        :visible="addInventoryTransferVisible"
        width="600px"
        :footer="null"
        @cancel="handleAddInventoryTransferCancel"
        >
        <a-spin :spinning="loading">
            <h3 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">Create Purchase Order</h3>
        <div>
            <a-form-model
                ref="addInventoryTransferForm"
                :model="addInventoryTransferModel"
                :rules="rules"
            >
            <a-row>
                <a-col :span="22" :offset="1">
                    <a-form-model-item label="Select Supplier" ref="supplierId" prop="supplierId">
                        <a-select v-model="addInventoryTransferModel.supplierId" placeholder="please select your option">
                            <a-select-option v-for="supplier in availableSuppliers" :key="supplier.id" v-bind:value="supplier.id">
                                {{ supplier.name }}
                            </a-select-option> 
                        </a-select>
                    </a-form-model-item>
                </a-col>
                
            </a-row>
            <!-- <div ref="productHeight" style="height: 200px; overflow-y: scroll">
                <a-row 
                v-for="(request, index) in addInventoryTransferModel.request"
                :key="request.key"
                type="flex" 
                justify="space-around"
                >
                <a-col :span="7" :offset="1">
                    <a-form-model-item 
                        label="Product Name" 
                        :prop="'request.' + index + '.productId'"
                        :rules="{
                            required: true,
                            message: 'Please choose your option',
                            trigger: 'change',
                        }"
                        >
                        <a-select
                            @change="(e) => onChangeProduct(request, e)"
                            show-search
                            placeholder="Choose your product"
                            option-filter-prop="children"
                            v-model="request.productId"
                            :filter-option="filterOption"
                        >
                            <a-select-option v-for="product in filteredProducts" :key="product.productId" v-bind:value="product.productId">
                                {{product.productBrandName}}
                            </a-select-option>
                        </a-select>
                        
                    </a-form-model-item>
                </a-col>
                <a-col :span="7" :offset="1">
                    <a-form-model-item 
                        label="Quantity" 
                        :prop="'request.' + index + '.quantity'"
                        :rules="[
                            {
                                required: true,
                                message: 'Please enter your quantity',
                                trigger: 'change',
                            },
                            
                        ]"
                        >
                            <a-input-number 
                                class="rightSideinputText"
                                type="number"
                                v-model="request.quantity"
                            />
                    </a-form-model-item>
                </a-col>
                <a-col :span="7" :offset="1">
                    <div style="margin-top: 53px;display:flex;justify-content: space-around">
                        <a-icon
                            v-if="addInventoryTransferModel.request.length > 1"
                            class="dynamic-delete-button"
                            type="minus-circle-o"
                            :disabled="addInventoryTransferModel.request.length === 1"
                            @click="removeDomain(request)"
                        />
                    </div>
                </a-col>
                
            </a-row>
            </div>
            <a-form-model-item class="pt-4" >
                <a-button :disabled="filteredProducts.length === 0"  style="margin:0 auto;float: right; background:#418a49; color:#fff;" @click="addDomain">
                    <a-icon type="plus" /> Add Product
                </a-button>
            </a-form-model-item> -->
            <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                <a-button @click="handleAddInventoryTransfer" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                    Create Pucrhase Order
                </a-button>
            </a-form-model-item>

            </a-form-model>
        </div>
        </a-spin>
        </a-modal>

        <!-- Select Backorders Filters -->
         <a-modal
        class="modalStyle"
        :visible="backOrderVisible"
        width="600px"
        :footer="null"
        @cancel="handleBackOrdersCancel"
        >
        <a-spin :spinning="loading">
            <!-- <p style="display:flex;justify-content: center;font-weight: bolder;align-items:center">
                
                 
            </p> -->
            <div>
                <h3 class="modalHeader pt-4">Please confirm the backorders you would like to generate</h3>
                <h3 class="modalHeader pt-1 text-center">Purchase orders from by selecting from the filter list</h3>
            </div>
            <div class="pt-3">
                <a-form-model
                    ref="backorderForm"
                    :model="backOrderModel"
                    :rules="rules"
                >
                <a-row>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Start Date" ref="startDate" prop="startDate">
                            <a-date-picker class="rightSideinputText" v-model="backOrderModel.startDate"  />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select End Date" ref="endDate" prop="endDate">
                            <a-date-picker class="rightSideinputText" v-model="backOrderModel.endDate"  />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Status" ref="status" prop="status">
                            <a-select  v-model="backOrderModel.status" placeholder="please select your option">
                                <a-select-option value="0">
                                    New
                                </a-select-option> 
                                <a-select-option value="1">
                                    Awaiting Confirmation
                                </a-select-option> 
                                <a-select-option value="2">
                                    Firmed
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Supplier" ref="supplierId" prop="supplierId">
                           <a-select
                                show-search
                                placeholder="Choose your suplier"
                                option-filter-prop="children"
                                v-model="backOrderModel.supplierId"
                                :filter-option="filterOption"
                            >
                                <a-select-option v-for="supplier in availableSuppliers" :key="supplier.id" v-bind:value="supplier.id">
                                    {{ supplier.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                
                <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                    <a-button @click="handleBackOrder" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                        Submit
                    </a-button>
                </a-form-model-item>

                </a-form-model>
            </div>
        </a-spin>
        </a-modal>

        <!-- Select Replenish  Filters -->
         <a-modal
        class="modalStyle"
        :visible="replenishVisible"
        width="600px"
        :footer="null"
        @cancel="handleReplenishCancel"
        >
        <a-spin :spinning="loading">
            <!-- <p style="display:flex;justify-content: center;font-weight: bolder;align-items:center">
                
                 
            </p> -->
            <div>
                <h3 class="modalHeader pt-1 text-center">Purchase orders from by selecting from the filter list</h3>
            </div>
            <div class="pt-3">
                <a-form-model
                    ref="replenishForm"
                    :model="replenishModel"
                    :rules="rules"
                >
                <a-row>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Start Date" ref="startDate" prop="startDate">
                            <a-date-picker class="rightSideinputText" v-model="replenishModel.startDate"  />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select End Date" ref="endDate" prop="endDate">
                            <a-date-picker class="rightSideinputText" v-model="replenishModel.endDate"  />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Status" ref="status" prop="status">
                            <a-select  v-model="replenishModel.status" placeholder="please select your option">
                                <a-select-option value="0">
                                    New
                                </a-select-option> 
                                <a-select-option value="1">
                                    AwaitingFulfillment
                                </a-select-option>
                                <a-select-option value="2">
                                    Fulfilling
                                </a-select-option>
                                <a-select-option value="3">
                                    Complete
                                </a-select-option>
                                <a-select-option value="4">
                                    Cancelled
                                </a-select-option>
                                <a-select-option value="5">
                                    Received
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Supplier" ref="supplierId" prop="supplierId">
                           <a-select
                                show-search
                                placeholder="Choose your suplier"
                                option-filter-prop="children"
                                v-model="replenishModel.supplierId"
                                :filter-option="filterOption"
                            >
                                <a-select-option v-for="supplier in availableSuppliers" :key="supplier.id" v-bind:value="supplier.id">
                                    {{ supplier.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                
                <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                    <a-button @click="handleReplenish" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                        Submit
                    </a-button>
                </a-form-model-item>

                </a-form-model>
            </div>
        </a-spin>
        </a-modal>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import { NotificationMixins } from "@/mixins/NotificationMixins";
import moment from 'moment';

    export default {
        name:'PurchaseOrderMenu',
        mixins: [NotificationMixins],
        data(){
            return{
                loading: false,
                addInventoryTransferVisible: false,
                backOrderVisible: false,
                replenishVisible: false,
                availableProducts:[],
                availableSuppliers:[],
                filteredProducts:[],
                backOrderModel:{
                    sstartDate: null,
                    endDate: null,
                    status: "",
                    supplierId:""
                },
                replenishModel:{
                    startDate: null,
                    endDate: null,
                    requestType: 1,
                    status: "",
                    supplierId:""
                },
                addInventoryTransferModel:{
                    request:[
                        {
                            productId:'',
                            quantity: '',
                            balance: 0,
                            key: Date.now()
                        }
                    ],
                    supplierId: ''
                },
                rules: {
                    locationId: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    startDate: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    endDate: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    supplierId: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    type: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    status: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    backOrderDate: [
                        { required: true, message: 'Please select date', trigger: 'change' }
                    ],
                    
                    productId: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    quantity: [
                        { required: true, message: 'Please enter your quantity', trigger: 'change' },
                        {
                                pattern: new RegExp(/^[1-9]\d*$/),
                                message: 'Please enter valid number',
                                trigger: 'change'
                        },
                    ],
                    distributionCenterId: [
                        { required: true, message: 'Please select where your products will be transfered to', trigger: 'change' }
                    ],
                },
            }
        },
        methods:{
            ...mapActions(['getAllSuppliers','getClientProducts','setPreviewInfo','setReplenishDataInfo','setBackOrderDataInfo']),
            showPurchaseOrderModal(){
                this.addInventoryTransferVisible = true
            },
            redirectToPurchaseOrderHistory(){
                this.$router.push({
                    name: 'purchase-order-history'
                    }).catch(()=>{})
            },
            redirectToRelenish(){
                this.replenishVisible = true

                // this.$router.push({
                //     name: 'replenish'
                //     }).catch(()=>{})
            },
            handleAddInventoryTransferCancel(){
                this.addInventoryTransferVisible = false
            },
            handleReplenishCancel(){
                this.replenishVisible = false
            },
            handleBackOrdersCancel(){
                this.backOrderVisible = false
            },
            showBackOrderModal(){
                this.backOrderVisible = true
            },
            handleBackOrder(){
                this.$refs.backorderForm.validate( async (valid) => {
                    if(valid){
                        
                        this.loading = true
                        const supplier = this.availableSuppliers.find(supplier => supplier.id === this.backOrderModel.supplierId)
                        const request = {
                            startDate : moment(this.backOrderModel.startDate).format(),
                            endDate : moment(this.backOrderModel.endDate).format(),
                            status: parseInt(this.backOrderModel.status),
                            supplierId: this.backOrderModel.supplierId
                        }

                        const response = await this.$store.dispatch("purchaseOrder/getBackOrder", request) 
                        
                        this.loading = false
                        if(response.status === 200){
                            this.$refs.backorderForm.resetFields()
                            this.showSuccessAlert("BackOrders Retrieved Successfully")
                            this.backOrderVisible = false
                            const backOderData = {
                                ...request,
                                supplier: supplier,
                                backOrders: response.data.data,
                                selectedOrders: []
                            }
                            this.setBackOrderDataInfo(JSON.stringify(backOderData))
                            this.$router.push({name: 'backorders'}).catch(()=>{})
                        }else{
                            this.showErrorAlert(response.data.messages)
                        }
                    }else{
                        return false;
                    }
                })
            },
             handleReplenish(){
                this.$refs.replenishForm.validate( async (valid) => {
                    if(valid){
                       this.loading = true
                       const supplier = this.availableSuppliers.find(supplier => supplier.id === this.replenishModel.supplierId)
                        const request = {
                            startDate : moment(this.replenishModel.startDate).format(),
                            endDate : moment(this.replenishModel.endDate).format(),
                            requestType: this.replenishModel.requestType,
                            status: parseInt(this.replenishModel.status),
                            supplierId: this.replenishModel.supplierId
                        }

                        const response = await this.$store.dispatch("purchaseOrder/getReplenishOrder", request) 
                        this.loading = false
                        if(response.status === 200){
                            this.$refs.replenishForm.resetFields()
                            this.showSuccessAlert("Purchase Orders Retrieved Successfully")
                            this.replenishVisible = false
                            const replenishData = {
                                ...request,
                                supplier: supplier,
                                replenisedOrder: response.data.data,
                                selectedOrdera: []
                            }
                            this.setReplenishDataInfo(JSON.stringify(replenishData))
                            this.$router.push({name: 'replenish'}).catch(()=>{})
                        }else{
                            this.showErrorAlert(response.data.messages)
                        }
                    }else{
                        return false;
                    }
                })
            },
            async onChangeSourceLocation(id){
                let params = {
                    page: -1,
                    perPage:-1,
                    searchBy: {
                        supplierId: id
                    },
                    sortBy: {}
                }
                this.getSuppliersProducts(params)
               
            },
            async getSuppliersProducts(request){
                this.loading = true
                const response = await this.getClientProducts(request)
                this.loading = false
                if(response.status === 200){
                    this.availableProducts = response.data.data.map(product => ({
                        productId: product.id,
                        productBrandName: product.brandName,
                        quantity: product.unitQuantity,
                        category: product.categoryName,
                        supplierName: product.supplierName,
                        manufacturerName: product.manufacturerName,
                        sellingPrice: product.sellingPrice,
                        purchasePrice: product.purchasePrice
                    }))
                    this.filteredProducts = this.availableProducts
                }else{
                    // console.log("Error | ", response)
                }
            },
            addDomain() {
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if(valid){
                        this.checkExistingProducts()
                        if(this.filteredProducts.length !== 0) {
                            this.addInventoryTransferModel.request.push({
                                productId: '',
                                quantity: '',
                                balance: 0,
                                key: Date.now()
                            });
                            this.scrollToEnd();
                        }
                    }else{
                        return false;
                    }
                })
            },
            scrollToEnd: function() { 
                const container = this.$refs.productHeight;
                container.scrollTop = container.scrollHeight;
            },
            removeDomain(item) {
                let index = this.addInventoryTransferModel.request.indexOf(item);
                if (index !== -1) {
                    this.addInventoryTransferModel.request.splice(index, 1);
                }
                this.checkExistingProducts()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            showTransfersLines(data){
                this.setWareHouseTransferLinesInfo(data)
                this.$router.push({
                    name: 'warehouse-transfers-lines',
                    params: { transferId: data.id }
                    }).catch(()=>{})
            },
            onChangeQuantity(request, quantity){
            
                let index = this.addInventoryTransferModel.request.indexOf(request);
                if(index !== -1){
                    let item = this.addInventoryTransferModel.request[index]

                    if(!item.productId){
                        this.showErrorAlert("Kindly select product")
                    }else{
                        if(!(quantity <= item.balance)){
                            this.showErrorAlert(`You've exceeded the quantity. Kindly choose between 1 to ${item.balance}`)
                        }
                    }
                }
            },
            checkExistingProducts(){
                const selectedProducts = this.addInventoryTransferModel.request.map(product => product.productId)
                const products = [];
                this.availableProducts.forEach(product => {
                    if(!(selectedProducts.includes(product.productId))){
                        products.push(product)
                    }
                })
                this.filteredProducts = products
            },
            onChangeProduct(request,productId){
                if(request.productId === productId){
                    const product = this.filteredProducts.find(product => product.productId === productId)
                    if(product){
                        let index = this.addInventoryTransferModel.request.indexOf(request);
                        let item = this.addInventoryTransferModel.request[index]
                        item.balance = product.balance
                        this.addInventoryTransferModel.request[index] = item
                    }
                }
            },
            handleAddInventoryTransfer(){
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                
                        const supplier = this.availableSuppliers.find(supplier => supplier.id === this.addInventoryTransferModel.supplierId)
                        
                        let previewData = { 
                            discount: '',
                            deliveryDate: '',
                            supplierName: supplier.name,
                            supplierId: supplier.id,
                            supplierAddress: supplier.address,
                            supplierCity: '',
                            supplierCountry: '',
                            destionation: '',
                            sellerAddress: '',
                            shipCity: '',
                            shipCountry:'',
                            shippingMethod: '',
                            shippinTerm: '',
                            tableData: [],
                            statusLabel: '',
                            action:"add",
                            deleiveries:[]
                        }
                        // console.log("previewData | ", previewData)
                        this.setPreviewInfo(JSON.stringify(previewData));  
                        this.$router.push('/purchase-order-edit').catch(()=>{});
                  
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            async loadSuppliers(){
                const response = await this.getAllSuppliers()
                if(response.status === 200){
                    this.availableSuppliers = response.data.data
                }else{
                    // console.log("Error | ", response)
                }
            }
        },
        created() {
            if(this.loadSuppliers){
                this.loadSuppliers()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .purchase-container{
        padding-top: 30px;
    }

    .box-container{
        padding: 10px;
        height: 115px;
        // border: 1px solid #61dc8780;
        border-radius: 20px;
        cursor: pointer;
    }

    .box-header{
        font-weight: bold;
        font-size: 20px;
        line-height: 32px;
        color: #247158;
        text-transform: capitalize;
    }

    .box-content{
        color: #4D4F5C;
        font-size: 13px;
        word-wrap: break-word;
    }

    .overlay{
        width:100%;
        height:100%;
        display:none;
        position:absolute;
        top:0px;
        left:0px;
        
    }
    .overlay div {
        position:relative;
        display:inline-block;
        top:45%;
        margin:-50% 5px 0 0;
    }

    .box-container { position:relative;display:inline-block; }
    .box-container:hover .overlay {
        display:block;
        background-color:rgba(0, 0, 0, 0.932);
        opacity:0.88;
        border-radius: 20px;
    }

    .btn-container{
        cursor: pointer; 
        border-raduis:5px; 
        text-align: center;
        z-index: -1;
    }

    .white{
        background: rgba(0, 0, 0, 0.5); 
        color:#fff;
        border: 1px solid #fff;
    }
    .green{
        background: #F2FFF2;
        border: 1px solid #061d05;
        text-align: center;
        text-transform: capitalize;
        color: #247158;
    }

    .btn-content{
        position: relative;
        left: 180px;
    }

    .box-alignment{
        display: flex;
        // justify-content: space-between;
        align-items: center;
    }

    .modalHeader{
        margin: 0 auto;
        width: 92%;
        font-size: 19px;
    }
    .rightSideinputText{
    width: 100%;
    border-radius: 5px;
}
</style>